<template>
  <DefaultPage id="about">
    <HeroTextSection id="aboutHero"
                     text="Mutual insurance created<br>by doctors <em>for</em> doctors"
                     video-id="397238455"
                     image-name="hero-about.jpg"
                     data-aos="fade"
    />
    <div id="our-message"
         data-aos="fade-right"
         data-aos-offset="0"
         data-aos-delay="200">
      <div class="grid-container">
        <div class="grid-x align-center">
          <div class="cell large-8 medium-10">
            <p>SVMIC is 100% owned and governed by our policyholders. We provide medical malpractice insurance and
              return an annual share of profits to policyholders. Physician involvement and physician governance mean
              that we are able to always keep your interests at heart.</p>
          </div>
        </div>
      </div>
    </div>
    <div id="our-mission"
         data-aos="fade-left">
      <div class="section-content">
        <div class="grid-x align-center">
          <div class="cell xlarge-6 large-8 medium-10">
            <h3>Our Mission</h3>
            <p>Protect, support, and advocate for physicians <br class="show-for-medium">and other healthcare providers.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div id="our-values"
         data-aos="fade"
         data-aos-duration="1000">
      <div class="grid-x grid-padding-x align-center">
        <div class="cell medium-10 large-8">
          <h3>Our Values</h3>
        </div>
        <ValuesSlider/>
      </div>
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import HeroTextSection from '@/components/section/HeroTextSection';
import ValuesSlider from '@/components/slider/ValuesSlider';

export default {
  name: 'About',
  components: {
    ValuesSlider,
    DefaultPage,
    HeroTextSection
  }
};
</script>
